import { observer } from 'mobx-react';
import {
  DrawDetailsModalShared,
  useDrawsStore,
} from '@roc/feature-draws';
import { PropertyDrawsAccordion } from './propertyDrawsAccordion';
import { useEffect, useState } from 'react';
import { useLoanRoutes } from '@roc/feature-loans-routes-config';
import { useHistory, useLocation } from 'react-router';
import { StandardDialog } from '@roc/ui';
import { useDocumentStore } from '@roc/feature-documents';
import { makeStyles } from '@material-ui/core/styles';
import { getDrawId } from '@roc/feature-utils';
import { Box, Typography } from '@material-ui/core';
import { getDrawNumber } from '../../utils/utils';

interface LoanDrawsListProps {
  loanId: string;
  properties: any[];
  isCPortal?: boolean;
}

const useStyles = makeStyles(theme => ({
  drawDetailsDialog: {
    '& .MuiDialog-paper': {
      minHeight: '35%'
    },
  },
}));


export const LoanDrawsList = observer(({ loanId, properties, isCPortal }: LoanDrawsListProps) => {
  const [selectedDrawId, setSelectedDrawId] = useState(null);
  const { loanRoutesConfig } = useLoanRoutes();
  const { pathname } = useLocation();
  const { push } = useHistory();
  const { drawStore } = useDrawsStore();
  const { documentStore } = useDocumentStore();
  const classes = useStyles();

  const onOpenDrawDetailsShared = (drawId: number) => {
    if (isCPortal) {
      push(loanRoutesConfig.loans(loanId).children.drawDetails(`${drawId}`).url);
    } else {
      setSelectedDrawId(drawId);
      drawStore.setIsDrawDetailsModalOpen(true);
    }
  }

  const onCloseDrawDetailsShared = () => {
    drawStore.setIsDrawDetailsModalOpen(false);
    if (isCPortal) {
      documentStore.loanTodosStore.fetchLoanDrawTodosPending(+loanId);
      drawStore.fetchDrawsAndRevisions(loanId);
    } else {
      drawStore.fetchDraws(loanId, true);
    }
    setSelectedDrawId(null);
    push(loanRoutesConfig.loans(loanId).children.draws.url);
  }

  const drawList = drawStore?.drawList || [];

  useEffect(() => {
    const getDrawIdNumberFromURL = (pathname) => {
      const drawIdURL = getDrawId(pathname);
      const drawIdNumber = Number(drawIdURL);
      return (drawIdNumber && !isNaN(drawIdNumber)) ? drawIdNumber : null;
    }

    if (isCPortal) {
      const drawIdNumber = getDrawIdNumberFromURL(pathname);

      if (drawIdNumber) {
        setSelectedDrawId(drawIdNumber);
        drawStore.setIsDrawDetailsModalOpen(true);
      }
    }
  }, [pathname, drawStore, isCPortal]);

  return (
    <>
      {(properties ?? []).map((property) => (<PropertyDrawsAccordion key={property.propertyId} loanId={loanId} draws={drawList.filter(draw => draw.propertyId === property.propertyId)} property={property} onDrawClick={onOpenDrawDetailsShared} />))}

      <StandardDialog
        open={drawStore.isDrawDetailsModalOpen && selectedDrawId}
        onClose={onCloseDrawDetailsShared}
        handleClose={onCloseDrawDetailsShared}
        maxWidth={'xl'}
        className={classes.drawDetailsDialog}
        title={(
          <Box>
            <Typography variant="h4">
              {getDrawNumber(drawStore?.currentDraw)}
            </Typography>
            <Typography variant="h6" color="textSecondary">
              {drawStore.currentDraw?.propertyAddress}
            </Typography>
          </Box>
        )}
        dialogContent={
          <DrawDetailsModalShared isCPortal={isCPortal} loanId={loanId} drawId={selectedDrawId} />}
        removeContentBox
      />
    </>
  );
});
